import { UserExperience } from '@wix/wix-help-widget-common/personalization';

import { experiments } from '../experiments';
import { renderModel } from './renderModel';

const DIY_USERS = [
  UserExperience.User,
  UserExperience.StudioClient,
  UserExperience.Vista,
  UserExperience.Headless,
  UserExperience.Dayful,
];
const isStudioEditor = renderModel.isStudioEditor();

const userExperience = renderModel.getUserContext()?.userExperience || UserExperience.User;

// For Phase 1 - we will show the new home page only to DIY users
const isDoItYourselfUser = DIY_USERS.includes(userExperience);

export const shouldShowNewHomePage = () => {
  const isHomepageRedesign = experiments.is('specs.helpwidget.newHomePage', 'true');
  return isDoItYourselfUser && isHomepageRedesign && !isStudioEditor;
};
